var map = {
	"./product1.json": "2085",
	"./product10.json": "de42",
	"./product11.json": "fb74",
	"./product2.json": "a31c",
	"./product3.json": "a2bb",
	"./product4.json": "b48b",
	"./product5.json": "5866",
	"./product6.json": "095f",
	"./product7.json": "4c21d",
	"./product8.json": "4643",
	"./product9.json": "a523"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2678";